import styled from 'styled-components';

export const Contain = styled.div`
  background-color: var(--background-second-sefaz);
  border-bottom: 1px solid #ffffff;

  svg,
  span {
    font-size: 13pt;
  }
  ul {
    background-color: var(--background-second-sefaz);
  }
  li {
    padding: 5px 10px !important;
  }
  #fas {
    margin-left: 1%;
    margin-right: 2%;
    font-weight: 700;
  }

  .ant-menu-item-selected,
  .ant-menu-submenu-selected {
    color: var(--primary-color-sefaz) !important;
  }
  .ant-menu-overflow-item {
    color: var(--texto-color);
  }
  .ant-menu-horizontal {
    line-height: 33px;
  }
`;

export const ContainerAcessibilidade = styled.div`
  width: 10%;
  margin-left: auto;
  text-align: right;
  .acessibity-icon.select {
    filter: invert(85%) sepia(98%) saturate(438%) hue-rotate(357deg) brightness(95%) contrast(95%) !important;
  }
`;

export const IconAcessibilidade = styled.img`
  height: 15px;
  margin: 10px;
  cursor: pointer;
`;
